<template>
  <div>正在载入中...</div>
</template>

<script>
export default {
  components: {},
  props: {},
  beforeCreate() {
    // 登录成功，直接去选择模块页面
    this.$authServices.getAuthState().then((res) => {
      if (res) {
        let sqCode = localStorage.getItem("sqCode");
        if (sqCode) {
          this.$authServices.logout();
        } else {
         // alert('单点登录:已登录')
          location.href = this.$config.baseUrl + "/userinfo/chooseModule"; // http://10.1.3.102:1040/islogin http://base.ahjxjy.cn/islogin
        }
      }
    });
  },
};
</script>
<style scoped></style>
